export default __webpack_public_path__ + "static/media/_IMG4309-274.b19ddfbf.jpg";